"use client"

import { useEffect } from "react"

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("[RootError]", error.message, error.stack, "url:", window.location.href)
  }, [error])

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="border border-red-200 bg-red-50 rounded-xl p-8 text-center">
        <h2 className="font-bold text-lg mb-2">Something went wrong</h2>
        <p className="text-sm text-red-700 mb-4">
          {error.message || "An unexpected error occurred."}
        </p>
        {error.stack && (
          <pre className="text-[10px] text-left bg-white border border-red-100 rounded-lg p-3 mb-4 max-h-48 overflow-auto whitespace-pre-wrap break-all text-red-400">
            {error.stack}
          </pre>
        )}
        {error.digest && (
          <p className="text-xs text-gray-400 mb-4">Digest: {error.digest}</p>
        )}
        <button
          onClick={reset}
          className="px-4 py-2 text-sm font-medium bg-white border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
